// EmptyCart.js
import React from 'react';
import styles from './EmptyCart.module.css';
import { NamedLink } from '../../../components';
import { FormattedMessage } from 'react-intl';

const EmptyCartSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 180"
      space="preserve"
      width="180"
      height="180"
    >
      <path d="M83.511 113.351a5.832 5.832 0 0 0 6.399 5.202 5.832 5.832 0 0 0 5.2 -6.399l-2.689 -26.021a5.83 5.83 0 0 0 -11.599 1.199zm36.491 5.202q0.306 0.031 0.607 0.031a5.832 5.832 0 0 0 5.792 -5.233l2.689 -26.021a5.832 5.832 0 0 0 -5.2 -6.399 5.832 5.832 0 0 0 -6.401 5.2l-2.689 26.021a5.832 5.832 0 0 0 5.202 6.401M74.853 143.899c-9.952 0 -18.049 8.096 -18.049 18.049 0 9.954 8.096 18.054 18.049 18.054s18.05 -8.098 18.05 -18.054c0 -9.952 -8.096 -18.049 -18.05 -18.049m0 24.439a6.395 6.395 0 0 1 -6.386 -6.392c0 -3.523 2.866 -6.386 6.386 -6.386s6.388 2.866 6.388 6.386a6.397 6.397 0 0 1 -6.388 6.392m60.208 -24.439c-9.952 0 -18.05 8.096 -18.05 18.049 0 9.954 8.096 18.054 18.05 18.054s18.05 -8.098 18.05 -18.054c0 -9.952 -8.098 -18.049 -18.05 -18.049m0 24.439a6.397 6.397 0 0 1 -6.388 -6.392 6.39 6.39 0 0 1 6.388 -6.386 6.397 6.397 0 0 1 6.39 6.386 6.397 6.397 0 0 1 -6.39 6.392" />
      <path d="M169.938 61.481a5.832 5.832 0 0 0 -4.613 -2.264h-116.226l-4.882 -18.769a5.832 5.832 0 0 0 -5.643 -4.363H14.675a5.83 5.83 0 0 0 0 11.662h19.39l4.842 18.617q0.036 0.157 0.081 0.31l18.004 69.23a5.832 5.832 0 0 0 5.643 4.363h84.645a5.832 5.832 0 0 0 5.643 -4.363l18.045 -69.388a5.832 5.832 0 0 0 -1.031 -5.033M142.771 128.606H67.144l-15.012 -57.726h105.653zm-60.705 -87.516a5.814 5.814 0 0 0 4.122 1.706 5.83 5.83 0 0 0 4.122 -9.956L71.971 14.512a5.832 5.832 0 0 0 -8.246 8.248zm41.686 1.706c1.492 0 2.986 -0.571 4.126 -1.71l18.311 -18.328a5.832 5.832 0 0 0 -0.004 -8.246 5.832 5.832 0 0 0 -8.246 0.004L119.628 32.845a5.83 5.83 0 0 0 4.124 9.952m-18.79 -5.236h0.002a5.832 5.832 0 0 0 5.83 -5.83l0.005 -25.898A5.832 5.832 0 0 0 104.971 0a5.832 5.832 0 0 0 -5.832 5.83l-0.005 25.898a5.832 5.832 0 0 0 5.83 5.832" />
    </svg>
  );
};

const EmptyCart = () => {
  return (
    <div className={styles.cartContainer}>
      <div className={styles.cartContent}>
        <EmptyCartSVG className={styles.cartIcon} />
        <p>
          <FormattedMessage id="CartPage.emptyCart.message" />
        </p>
        <NamedLink name="SearchPage" className={styles.goShoppingButton}>
          <FormattedMessage id="CartPage.emptyCart.shoppingButton" />
        </NamedLink>
      </div>
    </div>
  );
};

export default EmptyCart;
